module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    class: _vm.labelClass
  }, [_vm._v("\n    " + _vm._s(_vm.$t('bank_accounts.my_account')) + "\n    "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senderBank),
      expression: "senderBank"
    }],
    staticClass: "form-control",
    class: {
      'errorBorder': _vm.senderBankError
    },
    attrs: {
      "id": "sel2",
      "readonly": "",
      "disabled": this.readonly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.senderBank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.slct_an_acc')))]), _vm._v(" "), _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('option', {
      key: bankAccount.id,
      attrs: {
        "disabled": !_vm.isBankAccountAvailable(bankAccount)
      },
      domProps: {
        "value": bankAccount.iban
      }
    }, [_vm._v("\n      " + _vm._s(bankAccount.name) + " (" + _vm._s(_vm.$engine.bankAccounts.getCurrency(bankAccount.zoneCode)) + ")\n    ")])
  })], 2), _vm._v(" "), (_vm.senderBankError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('errors.is_mandatory', {
    mandatoryValue: _vm.$t('common.act')
  })) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72b6108c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b6108c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/components/selectBankAccount.vue
// module id = 2400
// module chunks = 2